import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, Subscription, switchMap, throwError } from 'rxjs';
import { changepasswordtok, emailtok, validatecode, validateemailval, validateretry } from '../../modules/auth/models/auth.model';


@Injectable({
  providedIn: 'root'
})
export class AuthservicesService {
  private ref: Subscription[] = []
  tokenNotExpired = false
  errMsg: number | undefined
  public token: any
  countDown: any
  countDownreset: any
  public timer: any
  count = 0
  countreset = 0
  public setItem: any
  public counter = 0
  constructor(private http: HttpClient) { }
  forgotpasswordPost(payload: any): Observable<object> {
    const httpOptions = { headers: { 'Content-Type': 'application/json' } };
    return this.http.post<any[]>(`/api/auth/request-password`, payload, httpOptions).pipe(
      catchError(this.handleError)
    );
  }

  resetPassword(payload: emailtok): Observable<object> {
    const httpOptions = { headers: { 'Content-Type': 'application/json' } };
    return this.http.post<any[]>(`/api/auth/restore-pass`, payload, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  resetnewPassword(payload: changepasswordtok): Observable<object> {
    const httpOptions = { headers: { 'Content-Type': 'application/json' } };
    return this.http.post<any[]>(`/api/auth/reset-pass`, payload, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
   register(credentials: any) {
    const getroleId =
      credentials['roles'].length < 1 ? null : credentials['roles'][0]
    return this.http.post<any>(`/api/auth/sign-up`, credentials).pipe(
      switchMap((data) => {
        if (data === 0) {
          return undefined
        }
        if (data === 50) {
          return 'This account already exists!'
        }
        const body = {
          Id: data.body,
          ThemeName: 'default',
          RoleId: getroleId,
        }
        return this.http.post(`/settings/createnewuser`, body)
      }),
    )
  }
  verifyToken(payload: validatecode): Observable<object> {
    const httpOptions = { headers: { 'Content-Type': 'application/json' } };
    return this.http.post<any[]>(`/api/auth/VerifyToken`, payload, httpOptions).pipe(
      catchError(this.handleError)
    );
  }
  registercurrentprofile(): Observable<any> {
    return this.http.get('/api/auth/SmsReRegister')
  }
  RetryverifyToken(mobile: validateretry): Observable<any> {
    return this.http.post<validateretry>('/api/auth/VoiceRegister', mobile)
  }
  registercemailprofile(): Observable<any> {
    return this.http.get('/api/auth/EmailRegisterGet')
  }
  registermobileprofile(): Observable<any> {
    return this.http.get('/api/auth/SmsReRegister')
  }
   registermobilenew(profile: any): Observable<any> {
    return this.http.post('/api/auth/SmsRegister', profile)
  }
  getUserByEmailSelect(email: string): Observable<any> {
    return this.http.post('/api/auth/GetUserByEmail', { emailAddress: email })
  }
  getUserByEmail(emaildata: validateemailval): Observable<any> {
    return this.http.post('/api/auth/EmailRegister', emaildata)
  }
  updateprofile(profile: any): Observable<any> {
    return this.http.post('/api/auth/UpdatenewProfile', profile)
  }
  registerRep(credentials: any): Observable<any> {
    return this.http.post<any>(`/api/auth/sign-up-rep`, credentials, { observe: 'response' }).pipe(
      map((response) => {
        if (response.status === 200 && !response.body) {
          return { succeeded: true };
        }
        return response.body;
      }),
      catchError((error) => {
        console.error('API Error:', error);
        return of({ succeeded: false, error: 'An error occurred, please try again.' });
      })
    );
  }
  ngOnDestroy() {
    this.ref.forEach((sb) => sb.unsubscribe())
  }
  private handleError(error: HttpErrorResponse): Observable<never> {
    let errorMessage = 'An unknown error occurred!';

    if (error.error instanceof ErrorEvent) {
      errorMessage = `Client Error: ${error.error.message}`;
    } else {
      errorMessage = `Server Error ${error.status}: ${error.message}`;
    }

    console.error(errorMessage);
    return throwError(() => new Error(errorMessage));
  }

}
